
import { useEffect, useLayoutEffect, useRef, useState } from "react";
import "./chat-transcript.component.scss";
import { convertSecondsToHHMMSS } from "../../../utility/function.utility";
import SPEAKER_MOCK from "../../../assets/images/speaker-mock.svg";
import Button from '@mui/material/Button';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { getUniqueSpeakerList } from "../../../utility/function.utility";
import { useSnackbar } from "../../../utility/snackbar.utility";
import CustomSnackbar from "../../snackbar/snackbar.component";
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';

const ChatTranscriptComponent = ({ transcriptList }: any) => {

    const { snackbar, showSnackbar, hideSnackbar } = useSnackbar();

    const ALL_SPEAKER = "All Speaker";
    const chatControlRef = useRef<HTMLDivElement | null>(null);

    const [selectedRole, setSelectedRole] = useState<string>(ALL_SPEAKER);
    const [transcripts, setTranscripts] = useState(transcriptList);
    const [speakerList, setSpeakerList] = useState<string[]>([]);
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

    const open = Boolean(anchorEl);

    useEffect(() => {
        setSpeakerList(getUniqueSpeakerList(transcriptList));
    }, []);

    useEffect(() => {
        if (selectedRole === ALL_SPEAKER) {
            setTranscripts(transcriptList);
        } else {
            setTranscripts(transcriptList.filter(item => item.role === selectedRole));
        }
    }, [selectedRole]);

    useLayoutEffect(() => {
        if (chatControlRef.current) {
            chatControlRef.current.scrollTop = 0;
        }
    }, [transcripts]);

    const handleTagClick = (role_name: string) => {
        setSelectedRole(role_name);
    };

    const handleClickMenu = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleCloseMenu = () => {
        setAnchorEl(null);
    };

    const handleCopyText = (text: string) => {
        navigator.clipboard.writeText(text)
            .then(() => {
                showSnackbar('ข้อความถูกคัดลอกแล้ว');
                handleCloseMenu();
            })
            .catch(() => showSnackbar('เกิดข้อผิดพลาดในการคัดลอกข้อความ', 'error'));
    };

    const handleCopy = () => {
        if (chatControlRef.current) {
            const textToCopy = chatControlRef.current.innerText;
            handleCopyText(textToCopy);
        }
    };

    const handleCopyOnlyText = () => {
        const textToCopy = transcripts.map(item => item.text).join('\n\n');
        handleCopyText(textToCopy);
    };

    return (
        <>
            <div className="chat-header">
                <div className="chat-tag-control">
                    {
                        speakerList && speakerList.map((item, index) => {
                            const isSelected = selectedRole === item;
                            const speakerClass = (index === 0) ? 'speaker-full' : `speaker-${(index % 5) || 5}`;

                            return (
                                <Button
                                    key={item}
                                    variant={isSelected ? "contained" : "outlined"}
                                    className={`chat-tag-button ${isSelected ? "active" : speakerClass}`}
                                    onClick={() => handleTagClick(item)}
                                >
                                    {
                                        (item === ALL_SPEAKER) ? 'ผู้พูดทั้งหมด' : item.replace('Speaker', 'ผู้พูด')
                                    }
                                </Button>
                            )
                        })
                    }
                </div>

                <div>
                    <Button
                        id="basic-button"
                        variant="text"
                        className="chat-copy-button"
                        startIcon={<ContentCopyIcon />}
                        aria-controls={open ? 'basic-menu' : undefined}
                        aria-haspopup="true"
                        aria-expanded={open ? 'true' : undefined}
                        onClick={handleClickMenu}
                    >
                        คัดลอก
                    </Button>
                    <Menu
                        id="basic-menu"
                        anchorEl={anchorEl}
                        open={open}
                        onClose={handleCloseMenu}
                        MenuListProps={{
                            'aria-labelledby': 'basic-button',
                        }}
                    >
                        <MenuItem onClick={handleCopy}>
                            คัดลอก
                        </MenuItem>
                        <MenuItem onClick={handleCopyOnlyText}>
                            คัดลอกเฉพาะเนื้อหา
                        </MenuItem>
                    </Menu>
                </div>
            </div>

            <div ref={chatControlRef} className="chat-control">
                <div className="chat-all-control">
                    {
                        transcripts && transcripts.map((item, index) => {
                            const speakerClass = `speaker-${((item.role.split(' ')[1] % 5) || 5)}`;

                            return (
                                <div key={index} className="chat-message-head-control">
                                    <img src={SPEAKER_MOCK} className="chat-message-head-icon" />

                                    <div className={`chat-message-speaker-control ${speakerClass}`}>
                                        <p className="chat-message-speaker">
                                            {item.role.replace('Speaker', 'ผู้พูด')}
                                        </p>

                                        <div className={`chat-message-control ${speakerClass}`}>
                                            <p className="chat-message-time">
                                                {convertSecondsToHHMMSS(item.start_time)}
                                            </p>

                                            <p className="chat-message-text">
                                                {item.text}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            )
                        })
                    }
                </div>
            </div>

            <CustomSnackbar
                open={snackbar.open}
                message={snackbar.message}
                severity={snackbar.severity}
                duration={snackbar.duration}
                onClose={hideSnackbar}
            />
        </>
    )
}

export default ChatTranscriptComponent;